import { Video } from "./types";

const faqsVideosObject = {
  "x3-vs-free-weights-or-resistance-bands": {
    title:
      "How is X3 different from free weights (dumbbells and barbells) or typical resistance bands?",
    videoId: "21f302f076137f7ea089bdd7650e1bd9",
    transcriptPath:
      "/transcripts/faqs/x3-vs-free-weights-or-resistance-bands.md",
  },
  "choosing-x3-band-and-reps": {
    title:
      "How do I pick the right X3 band? How many repetitions should I do with X3?",
    videoId: "bbbba2c850d5ad1de272b9fbb3c1e299",
    transcriptPath: "/transcripts/faqs/choosing-x3-band-and-reps.md",
  },
  "science-behind-x3-bar": {
    title: "Variable Resistance Training: What's the science behind X3 Bar?",
    videoId: "7dc2f84e4799d88da986d18844a028e1",
    transcriptPath: "/transcripts/faqs/science-behind-x3-bar.md",
  },
  "why-one-set-and-rest-times": {
    title: "Why only one set? How long should I rest between X3 bar exercises?",
    videoId: "597b97fe90a88d9dedcf0c34af20a07d",
    transcriptPath: "/transcripts/faqs/why-one-set-and-rest-times.md",
  },
  "will-i-bulk-up-using-x3": {
    title: "Will I bulk up and build muscle using X3?",
    videoId: "3865cf84d9443b0680dc801956e3ebf7",
    transcriptPath: "/transcripts/faqs/will-i-bulk-up-using-x3.md",
  },
  "x3-bicep-curl-vs-typical-curl": {
    title: "Why is the X3 bicep curl different than a typical bicep curl?",
    videoId: "010227de8e7724e1f52b8a58e42012cd",
    transcriptPath: "/transcripts/faqs/x3-bicep-curl-vs-typical-curl.md",
  },
  "x3-bar-suitability-for-tall-or-wide-shoulders": {
    title: "Am I too tall or are my shoulders too wide for X3 bar?",
    videoId: "4d28643d40d034a3c5cececc5b6daf69",
    transcriptPath:
      "/transcripts/faqs/x3-bar-suitability-for-tall-or-wide-shoulders.md",
  },
  "why-no-cardio-in-x3-program": {
    title: "Why isn't cardio part of the X3 12 week program?",
    videoId: "18b6e87d8139e3b2897bb107a92125ed",
    transcriptPath: "/transcripts/faqs/why-no-cardio-in-x3-program.md",
  },
  "x3-chest-press-positioning-and-band-slip": {
    title:
      "How do I get into position for the X3 chest press to prevent the bands from slipping?",
    videoId: "b07562616753426a375027e8df8d6ef6",
    transcriptPath:
      "/transcripts/faqs/x3-chest-press-positioning-and-band-slip.md",
  },
  "x3-without-bar-or-alternatives": {
    title:
      "Can I use X3 without the bar or plate? What about X3 Bar alternatives?",
    videoId: "d802a687703dbdba31a6d46c19c0baca",
    transcriptPath: "/transcripts/faqs/x3-without-bar-or-alternatives.md",
  },
  "calculating-protein-needs-for-muscle": {
    title: "How do I calculate the amount of protein I need to build muscle?",
    videoId: "a5935992f9b9a699a9e117f5d40e2d56",
    transcriptPath: "/transcripts/faqs/calculating-protein-needs-for-muscle.md",
  },
  "best-time-to-take-fortagen": {
    title:
      "When is the best time to take Fortagen? How many servings can I have?",
    videoId: "ef77c3ed6430c9b06bf96b037e155c64",
    transcriptPath: "/transcripts/faqs/best-time-to-take-fortagen.md",
  },
  "why-x3-costs-549": {
    title: "Why does X3 cost $549?",
    videoId: "71e570c387a3337b17d290a02319ab99",
    transcriptPath: "/transcripts/faqs/why-x3-costs-549.md",
  },
  "using-separate-handles-with-x3": {
    title: "Can I use separate handles with the X3?",
    videoId: "fc04e6f1c39f59fe703b39cb9b46b18c",
    transcriptPath: "/transcripts/faqs/using-separate-handles-with-x3.md",
  },
  "worn-or-frayed-x3-bands": {
    title: "Why does my X3 band look worn, frayed, or torn?",
    videoId: "5a99d553e309700dee39051afdfa0e62",
    transcriptPath: "/transcripts/faqs/worn-or-frayed-x3-bands.md",
  },
  "trt-vs-steroids": {
    title:
      "Is testosterone replacement therapy (TRT) the same as taking steroids?",
    videoId: "ccc6ec3bff35d27d77dce08941ccd215",
    transcriptPath: "/transcripts/faqs/trt-vs-steroids.md",
  },
  "why-x3-bar-has-negative-feedback": {
    title: "Why does X3 bar have so many negative?",
    videoId: "df0c4ffeebac17e8f4c1afb23050c52d",
    transcriptPath: "/transcripts/faqs/why-x3-bar-has-negative-feedback.md",
  },
};

export const faqsVideos: Record<string, Video> = Object.entries(
  faqsVideosObject,
).reduce(
  (acc, [slug, data]) => {
    acc[slug] = { slug, ...data };
    return acc;
  },
  {} as Record<string, Video>,
);
